import { render, staticRenderFns } from "./p34.vue?vue&type=template&id=218598a8&scoped=true&"
import script from "./p34.vue?vue&type=script&lang=js&"
export * from "./p34.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218598a8",
  null
  
)

export default component.exports